import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitoimagicacab() {



    const cardData = {

keyword: "Mumbai to Imagica Cab",

headingDescription:
    "Mumbai Airport Cab offers safe, comfortable, and reliable Mumbai to Imagica Cab services for families, kids, tourists, corporate outings, school trips, and weekend travelers. We provide well-maintained Sedan, SUV, Innova Crysta, Ertiga, Tempo Traveller, Luxury Urbania, and Mini Bus options with experienced chauffeurs for a smooth highway journey via the Mumbai–Pune Expressway. With doorstep pickup across Mumbai, Mumbai Airport transfers, one-way and round-trip cab bookings, flexible travel plans, 24/7 customer support, and transparent pricing, we ensure a hassle-free and fun-filled travel experience to Imagicaa Theme Park, one of India’s most popular entertainment destinations known for thrilling rides, water parks, live shows, adventure zones, and family attractions.",

topPlaces: [
    {
        title: "Imagicaa Theme Park",
        description:
            "Imagicaa Theme Park is India’s premier entertainment destination offering world-class rides, themed zones, and immersive experiences for all age groups. Visitors enjoy high-adrenaline roller coasters, family rides, kids’ attractions, live entertainment shows, and themed restaurants. The park is designed to provide a complete day of fun and adventure, making it the main highlight of a Mumbai to Imagica cab journey."
    },
    {
        title: "Imagicaa Water Park",
        description:
            "Imagicaa Water Park is a vibrant aquatic attraction featuring exciting water slides, wave pools, lazy rivers, and splash zones. It is perfect for families and groups looking to relax and enjoy water-based fun. The park offers a safe and enjoyable environment with multiple attractions suitable for both kids and adults."
    },
    {
        title: "Imagica Snow Park",
        description:
            "Imagica Snow Park offers a unique winter experience with real snow, ice slides, snowball fights, and sub-zero temperature zones. Visitors can enjoy snow activities, indoor games, and themed experiences that simulate a snowy environment, making it a popular attraction for families and children."
    },
    {
        title: "Golden Valley Resort Area",
        description:
            "The Golden Valley Resort area near Imagicaa offers comfortable accommodation, dining options, and scenic surroundings for travelers. Many visitors choose to stay here for overnight trips, enjoying peaceful views of the Sahyadri hills and easy access to the theme park."
    },
    {
        title: "Khopoli Scenic Hills",
        description:
            "Khopoli is surrounded by beautiful Sahyadri mountain ranges and lush green landscapes. The drive from Mumbai to Imagica passes through scenic highways, tunnels, and hill views, especially stunning during the monsoon season. Travelers enjoy photography stops and refreshing natural scenery along the way."
    },
    {
        title: "Bhira Dam Area",
        description:
            "Bhira Dam is a scenic water reservoir located near Imagicaa offering peaceful surroundings and natural beauty. The area is ideal for relaxation, photography, and short breaks during the journey. Its calm environment adds to the overall travel experience for tourists heading to Imagica."
    },
    {
        title: "Karla Caves (Enroute Option)",
        description:
            "Karla Caves are ancient Buddhist rock-cut caves located near Lonavala and can be visited as a detour during a Mumbai to Imagica trip. Known for their historical significance, intricate carvings, and massive prayer hall, the caves offer a cultural and spiritual experience for history enthusiasts."
    },
    {
        title: "Lonavala Hill Station",
        description:
            "Lonavala is one of Maharashtra’s most famous hill stations located near Imagicaa. It is known for waterfalls, viewpoints, chikki shops, and lush greenery. Many travelers combine Imagica trips with a Lonavala sightseeing tour for a complete weekend getaway experience."
    },
    {
        title: "Khandala Valley Viewpoints",
        description:
            "Khandala offers breathtaking valley views, misty hills, and scenic viewpoints along the Mumbai–Pune Expressway. Travelers often stop here to enjoy photography, cool breeze, and natural landscapes during their journey to Imagicaa Theme Park."
    },
    {
        title: "Della Adventure Park (Nearby Attraction)",
        description:
            "Della Adventure Park near Lonavala is one of India’s largest extreme adventure parks offering activities like bungee jumping, ATV rides, ziplining, and outdoor adventures. It is a popular add-on destination for travelers looking to extend their Mumbai to Imagica trip with more excitement."
    }
],



services: [
{
name: "Mumbai to Imagica Cab",
description: "Mumbai Airport Cab offers Mumbai to Imagica Cab service for safe, comfortable, and affordable travel to Adlabs Imagica Theme Park near Khopoli. Whether you are planning a family outing, weekend trip, school picnic, corporate team outing, group tour, or fun-filled holiday, we provide well-maintained AC Sedan, Ertiga, Innova Crysta, Kia Carens, SUV, Tempo Traveller, Force Urbania, and luxury vehicles. Our professional chauffeurs ensure a smooth journey via Mumbai-Pune Expressway with doorstep pickup, flexible schedules, one way and round trip options, transparent pricing, and 24x7 booking support. We provide pickup from Mumbai City, Mumbai Airport, Navi Mumbai, Thane, and nearby areas for a hassle-free and enjoyable theme park travel experience."
},
{
name: "Mumbai to Imagica Taxi",
description: "Book Mumbai to Imagica Taxi with Mumbai Airport Cab for convenient and reliable travel to Imagica Theme Park. Enjoy clean AC vehicles, experienced drivers, affordable fares, and flexible pickup options suitable for families, kids, and group outings."
},
{
name: "Mumbai to Imagica Taxi Fare",
description: "Get affordable Mumbai to Imagica Taxi Fare with Mumbai Airport Cab. We offer transparent pricing, no hidden charges, multiple vehicle options, and cost-effective packages for one way and round trip journeys."
},
{
name: "Mumbai to Imagica Cab Fare",
description: "Mumbai Airport Cab provides competitive Mumbai to Imagica Cab Fare with professional chauffeurs, comfortable vehicles, and flexible travel plans suitable for family trips and group travel."
},
{
name: "Cab from Mumbai to Imagica",
description: "Choose Cab from Mumbai to Imagica with Mumbai Airport Cab for safe, comfortable, and reliable transportation with experienced drivers and well-maintained AC vehicles for a fun day trip."
},
{
name: "Mumbai to Imagica Car Rental",
description: "Book Mumbai to Imagica Car Rental with chauffeur-driven Sedan, Ertiga, Innova Crysta, SUV, Tempo Traveller, and luxury vehicles for a flexible and enjoyable theme park visit."
},
{
name: "Mumbai to Imagica Cab Booking",
description: "Mumbai Airport Cab offers Mumbai to Imagica Cab Booking with instant confirmation, 24x7 support, professional drivers, and multiple vehicle choices for easy travel planning."
},
{
name: "Mumbai to Imagica One Way Cab",
description: "Travel conveniently with Mumbai to Imagica One Way Cab service featuring fixed pricing, comfortable AC vehicles, professional chauffeurs, and hassle-free drop to Imagica."
},
{
name: "Mumbai to Imagica Round Trip Cab",
description: "Mumbai Airport Cab provides Mumbai to Imagica Round Trip Cab packages for same-day return trips, family outings, corporate events, and weekend entertainment plans with flexible timings."
},
{
name: "Mumbai to Imagica Outstation Cab",
description: "Book Mumbai to Imagica Outstation Cab for comfortable long-distance travel with premium vehicles, experienced drivers, affordable rates, and reliable service for a stress-free journey."
},
{
name: "Mumbai to Imagica Theme Park Cab",
description: "Mumbai Airport Cab offers Mumbai to Imagica Theme Park Cab service with safe transportation, family-friendly vehicles, and smooth highway travel for a complete entertainment experience."
},
{
name: "Mumbai to Imagica Family Cab",
description: "Choose Mumbai to Imagica Family Cab with spacious vehicles, comfortable seating, and professional drivers ensuring a safe and enjoyable family trip to Imagica."
},
{
name: "Mumbai to Imagica Weekend Cab",
description: "Mumbai Airport Cab provides Mumbai to Imagica Weekend Cab service for relaxing weekend getaways with flexible pickup timings, affordable fares, and comfortable travel options."
},
{
name: "Mumbai Airport to Imagica Cab",
description: "Book Mumbai Airport to Imagica Cab with direct pickup from domestic and international terminals. We offer flight tracking, luggage assistance, and comfortable AC vehicles for smooth travel."
},
{
name: "Navi Mumbai to Imagica Cab",
description: "Mumbai Airport Cab offers Navi Mumbai to Imagica Cab service with doorstep pickup, affordable pricing, and reliable transportation for families and group travellers."
},
{
name: "Thane to Imagica Cab",
description: "Choose Thane to Imagica Cab with Mumbai Airport Cab for safe, comfortable, and affordable travel with professional chauffeurs and well-maintained vehicles."
},
{
name: "Mumbai to Imagica SUV Cab",
description: "Mumbai Airport Cab provides Mumbai to Imagica SUV Cab service for larger families and groups needing spacious interiors, premium comfort, and smooth highway travel."
},
{
name: "Mumbai to Imagica Innova Cab",
description: "Book Mumbai to Imagica Innova Cab with Mumbai Airport Cab for spacious seating, premium comfort, and reliable transportation ideal for family and group trips."
},
{
name: "Mumbai to Imagica Ertiga Cab",
description: "Choose Mumbai to Imagica Ertiga Cab for economical and comfortable family travel with AC comfort, professional drivers, and affordable pricing."
}
],

tableData: [
["Mumbai to Imagica Cab","Mumbai to Imagica Taxi"],
["Mumbai to Imagica Taxi Fare","Mumbai to Imagica Cab Fare"],
["Cab from Mumbai to Imagica","Mumbai to Imagica Car Rental"],
["Mumbai to Imagica Cab Booking","Mumbai to Imagica One Way Cab"],
["Mumbai to Imagica Round Trip Cab","Mumbai to Imagica Outstation Cab"],
["Mumbai to Imagica Family Cab","Mumbai to Imagica Weekend Cab"],
["Mumbai Airport to Imagica Cab","Navi Mumbai to Imagica Cab"],
["Thane to Imagica Cab","Mumbai to Imagica SUV Cab"],
["Mumbai to Imagica Innova Cab","Mumbai to Imagica Ertiga Cab"]
],



whychoose: [
{
WhyChooseheading: "Reliable Mumbai to Imagica Cab Service",
WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Imagica Cab transportation for families, tourists, couples, school groups, corporate teams, and adventure enthusiasts seeking comfortable travel."
},
{
WhyChooseheading: "Perfect Theme Park Travel Solution",
WhyChoosedescription: "Imagica is one of India's most popular amusement destinations, and our cab service offers convenient transportation for a fun-filled day trip."
},
{
WhyChooseheading: "Comfortable Door-to-Door Travel",
WhyChoosedescription: "Avoid the hassle of public transport and enjoy direct pickup and drop services from your location in Mumbai to Imagica."
},
{
WhyChooseheading: "Multiple Vehicle Options Available",
WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and luxury vehicles according to passenger count and travel requirements."
},
{
WhyChooseheading: "One-Way and Round Trip Booking",
WhyChoosedescription: "Whether you need a one-way drop, same-day return, family outing package, or group travel arrangement, we provide flexible booking options."
},
{
WhyChooseheading: "Pickup Available Across Mumbai",
WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
},
{
WhyChooseheading: "Safe and Professional Drivers",
WhyChoosedescription: "Our experienced chauffeurs and regularly maintained vehicles ensure safe, comfortable, and stress-free travel for all passengers."
},
{
WhyChooseheading: "Ideal for Families and Group Outings",
WhyChoosedescription: "From family vacations and birthday celebrations to corporate outings and school trips, we provide suitable vehicle options for every group size."
}
]
};

const faqData = [
{
question: "Why do travelers book Mumbai to Imagica Cabs?",
answer: "Many travelers prefer cab services because they provide direct, comfortable, and convenient transportation to Imagica without travel hassles."
},
{
question: "Can I book a one-way cab from Mumbai to Imagica?",
answer: "Yes, one-way cab services are available along with round-trip and same-day return packages."
},
{
question: "Which vehicle is suitable for Mumbai to Imagica travel?",
answer: "Sedan cars, Ertiga, Innova Crysta, SUVs, and Tempo Travellers are popular choices depending on passenger count."
},
{
question: "Do you provide same-day return trips?",
answer: "Yes, customers can book same-day return packages for convenient travel to and from Imagica."
},
{
question: "Can families use this service for theme park visits?",
answer: "Yes, families frequently choose Mumbai Airport Cabs for comfortable travel to Imagica and nearby attractions."
},
{
question: "Are Tempo Travellers available for groups?",
answer: "Yes, Tempo Travellers and larger vehicles are available for school groups, corporate teams, and family outings."
},
{
question: "Can I get pickup from Mumbai Airport?",
answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
},
{
question: "Can multiple pickup points be arranged?",
answer: "Yes, customers can request multiple pickup locations depending on their group travel requirements."
},
{
question: "Is advance booking recommended for Imagica travel?",
answer: "Yes, advance booking helps secure your preferred vehicle, especially during weekends, holidays, and vacation seasons."
},
{
question: "How can I book a Mumbai to Imagica Cab?",
answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Rohan Patil",
feedback:
"The trip to Imagica was perfectly organized. The cab arrived on time, the vehicle was clean, and the driver ensured a comfortable journey for our entire family.",
rating: 5
},
{
id: 2,
name: "Mrs. Neha Shah",
feedback:
"Mumbai Airport Cabs made our Imagica outing stress-free and enjoyable. The service was professional, the vehicle was spacious, and the travel experience was excellent.",
rating: 5
}
];










































   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Mumbai to Imagica Cab",
"image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-imagica-cab.jpg",
"description": "Book Mumbai to Imagica cab service for a fun and comfortable family trip. Mumbai Airport Cabs offers reliable taxi service with professional drivers, clean vehicles, transparent pricing, and flexible one-way and round-trip options to Imagica Theme Park from Mumbai, Navi Mumbai, and Mumbai Airport.",
"brand": {
"@type": "Brand",
"name": "Mumbai Airport Cabs"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.mumbaiairportcabs.com/mumbai-to-imagica-cab"
}
};




    return (
        <div>



<Helmet>
  <title>Mumbai to Imagica Cab | Theme Park Taxi Service | +91 9545731161</title>

<meta
 name="description"
 content="Book Mumbai to Imagica cab service for a hassle-free theme park trip. Affordable taxi service with professional drivers, comfortable cars, and flexible one-way and round-trip options from Mumbai, Navi Mumbai, and airport."
/>

<meta
 name="keywords"
 content="mumbai to imagica cab, mumbai to imagica taxi, mumbai to imagica taxi fare, mumbai to imagica cab fare, cab from mumbai to imagica, mumbai to imagica car rental, mumbai to imagica cab booking, mumbai to imagica one way cab, mumbai to imagica round trip cab, mumbai to imagica outstation cab, mumbai to imagica theme park cab, mumbai to imagica family cab, mumbai to imagica weekend cab, mumbai airport to imagica cab, navi mumbai to imagica cab"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>







            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/87.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitoimagicacab;